import React from 'react';
import { withRouter } from 'react-router';
import { AcDetailsContainer } from '../../containers';

const AcDetailsPage = () => <AcDetailsContainer />;

export default withRouter(AcDetailsPage);
